/**
 * @author Tommy Brière
 * @copyright (c) 2013 Groupe PVP
 * @fileoverview Handle image preloading
**/
(function($, $g) {

    var Loader = $g.Loader;

    function ImageLoader() {
        Loader.call(this);
        var me = this;
        var nbConsecError = 0;
        me.nbLoad = 0;
        me.nbAssets = 0;

        var COOLDOWNS = [1, 30, 1000, 4 * 1000, 10 * 1000]

        /**
         * Load an image
         * Automatically search in the "fr" folder before searching for neutral image
         * @param id string  {activity}/{image}.{jpg}
         * @param progres    called repeatedly until the loading is complete
         * @return int  one of the flags [ACCEPTED,BUSY,NOT_NEW]
         */
        this.load = function(id, src, progres) {
            var nbFail = 0;

            function load() {
                var img = $("<img/>");
                var i0 = img[0];
                var data = {src:src, img:img, result: i0, error: 0};

                function clean() {
                    img.unbind();
                }

                function fail(err) {
                    var cooldown = COOLDOWNS[nbConsecError] || 10 * 1000;
                    me.nbLoad--;
                    nbConsecError++;
                    data.error++;
                    setTimeout(function() {
                        progres(Loader.FAILED, err);
                    }, cooldown);
                }
    

                me.items[id] = data;
                img.load(function() {
                    clean();
                    /* plus lent plus fiable ? */
                    setTimeout(function() {
                        var cmp = i0.complete;
                        if (cmp || typeof cmp == "undefined") {
                            me.nbLoad--;
                            nbConsecError=0;
                            data.error=0;
                            me.nbAssets++;
                            progres(Loader.COMPLETE);
                        } else {
                            fail();
                        }
                    }, 1);
                }).error(function(err) {
                    clean();
                    nbFail++;
                    if (nbFail>1) {
                        fail(err);
                    } else {
                        load();
                    }
                });
                img.attr("src", src);
            }

            //try again failed asset
            if (me.items[id] && me.items[id].error===0) {
                setTimeout(function() {
                    if (me.items[id].result.complete) {
                        progres(Loader.COMPLETE);
                    }
                },1);
                return Loader.NOT_NEW;
            } else {
                me.nbLoad++;
                load();
                return Loader.ACCEPTED;
            }
        };
    }

    $g.ImageLoader = ImageLoader;

})(jQuery, PVPGEngine);
